import { Page } from '@shopify/polaris';
import { Dashboard } from './components/Dashboard';
import { InstallGate } from './components/InstallGate';

export default function App() {
  return (
    <Page title="Unifd">
      <InstallGate>
        <Dashboard />
      </InstallGate>
    </Page>
  );
}
